import script from "./approvalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./approvalDetail.vue?vue&type=script&setup=true&lang=js"

import "./approvalDetail.vue?vue&type=style&index=0&id=20580c32&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/h-waterwork-storeroom-webui_prev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20580c32"]])

export default __exports__